import React, {Component} from 'react';
import Button from '../../UI/Button/Button';
import Input from '../../UI/Input/Input';

class rebuildCacheMyuhcPopUp extends Component {

    state = {
        rebuildPopUpForm: {
            targetPortal: {
                elementType: 'select',
                elementConfig: {
                    type: 'text',
                    id: 'targetPortal',
                    placeholder: 'Select One',
                    options: [
                        { value: 'MYUHC', displayValue: 'MyUHC (http://myuhc.com)' },
                        { value: 'BSCA', displayValue: 'Blue Shield California (https://www.yourdentalplan.com/bsca)' },
                        { value: 'HARVARDPILGRIM', displayValue: 'Harvard Pilgrim (https://www.yourdentalplan.com/harvardpilgrim)' },
                        { value: 'MORGANWHITE', displayValue: 'Morgan White (https://www.yourdentalplan.com/morganwhite)' }
                    ]
                },                
                value: '',
                validation: {
                    required: false
                },
                disabled: false,
                valid: true,
                touched: false,
                label: "Target Portal",
                inputType: "TwoThirdMarginLeft",
            }
        },
        formIsValid: false,
        message: null,
        popUpMessage: null,
    }

    inputChangedHandler =(event, inputIdentifier) => {

        let updatedForm = {...this.state.rebuildPopUpForm};

        const updatedFormElement = { ...updatedForm[inputIdentifier] };
        updatedFormElement.value = event.target.value;
        updatedForm[inputIdentifier] = updatedFormElement;
        
        this.setState({rebuildPopUpForm: updatedForm});
    }

    rebuildPopUpHandler = (event) => {
        event.preventDefault();
        let formData = this.props.mbrPortalInfo;
        formData.portalShortNm = this.state.rebuildPopUpForm['targetPortal'].value;
        formData.uuid = this.props.uuid;
        formData.isSdkPortal = this.props.sdkPortalList && this.props.sdkPortalList.find(o => o.portalShortName === formData.portalShortNm) ? true : false;
        formData.userName = this.props.userName;
        this.props.rebuildCache(formData);  
        this.props.modalClosed();
    }

    render() {

        const formsElementsArray =[];

        for(let key in this.state.rebuildPopUpForm) {
            formsElementsArray.push({
                id: key,
                config: this.state.rebuildPopUpForm[key]
            });
        }   
        
        let buttons = (
            <div style={{ display: "flex", justifyContent: "center"}}>
                <Button id="cancel" btnType="Cancel" clicked={this.props.modalClosed}>Cancel</Button>
                <Button id="rebuildCache" btnType="Search" clicked={this.rebuildPopUpHandler} disabled={!this.state.rebuildPopUpForm['targetPortal'].value}>Rebuild Cache</Button>
            </div>
        );

        let rebuildPopUpForm = (
            <form onSubmit={this.rebuildPopUpHandler}>
                <div>
                    {formsElementsArray.map(formElement => (
                        <Input
                            key={formElement.id}
                            elementType={formElement.config.elementType}
                            elementConfig={formElement.config.elementConfig}
                            value={formElement.config.value}
                            invalid={!formElement.config.valid}
                            shouldValidate={formElement.config.validation}
                            touched={formElement.config.touched}
                            disabled={formElement.config.disabled}
                            disableMobApp={formElement.config.disableMobApp}
                            label={formElement.config.label}
                            changed={(event) => this.inputChangedHandler(event, formElement.id)}
                            extendedInput={formElement.config.extendedInput}
                            inputType={formElement.config.inputType}
                        />
                    ))}
                </div>
                {buttons}
            </form>
        );

        return (
            <div>
                {rebuildPopUpForm}
            </div>
        );
    }
}

export default rebuildCacheMyuhcPopUp;